import { AUDIO_TYPES, parseAudioTypes } from "../../data/audioTypes";

// Dates are stored as plain days, so they are read and shown in UTC: a local Date would show
// the day before for anyone west of UTC.
const DAY_FORMAT = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", month: "short", day: "numeric", year: "numeric" });

export function formatCreativeDate(day) {
  return DAY_FORMAT.format(new Date(`${day}T00:00:00Z`));
}

export function audioTypesLabel(audioTypes) {
  if (audioTypes.length === 0) return "All Types";
  return audioTypes.map((t) => {
    const label = t.display_name || t.name || t.value || "Unknown";
    return t.clusivity === "exclude" ? `¬${label}` : label;
  }).join(", ");
}

// Every type included means no restriction, which is stored as the empty list.
export function resolveAudioTypes(audioTypes) {
  const allIncluded = audioTypes.length === AUDIO_TYPES.length &&
    AUDIO_TYPES.every((type) => audioTypes.some((t) => t.value === type.value && t.clusivity === "include"));
  return allIncluded ? [] : audioTypes;
}

export function dateRangeError(startDate, endDate) {
  return startDate && endDate && endDate < startDate ? "End date must be after start date." : null;
}

// True when the stored list, as read from the database, has an entry the edit form would lose.
// Every save resends the whole list, so losing one can widen targeting to all inventory.
export function hasUnreadableAudioTypes(stored) {
  return Array.isArray(stored) && normalizeAudioTypes(parseAudioTypes(stored)).length < stored.length;
}

// A stored entry as the picker's catalog entry, keeping its clusivity. Portal requires every
// field as a string, which older rows may not have. A numeric type the catalog does not list
// is kept: every save resends the whole list, so dropping it would widen the creative's
// targeting on an unrelated edit.
export function normalizeAudioTypes(stored) {
  return stored.flatMap((entry) => {
    const value = String(entry.value);
    const clusivity = entry.clusivity === "exclude" ? "exclude" : "include";
    const type = AUDIO_TYPES.find((t) => t.value === value);
    if (type) return [{ ...type, clusivity }];
    if (!/^\d+$/.test(value)) return [];
    return [{
      display_name: String(entry.display_name ?? entry.name ?? `Type ${value}`),
      id: String(entry.id ?? value),
      type: String(entry.type ?? "inventory_type"),
      value,
      clusivity,
    }];
  });
}
